import {
	BulkCreateHoldingEventDto,
	CreateHoldingEventDto,
	UpdateHoldingEventDto,
} from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';

export const createHoldingsEvent = async (
	createHoldingsEventDto: CreateHoldingEventDto
): Promise<CreateHoldingEventDto> => {
	const endpoint = formatUnicorn(API_PATHS.CAP_HOLDINGS_EVENT_CREATE_HOLDINGS_EVENT_POST, {});
	return makeRequest<ApiV1.Response<CreateHoldingEventDto>>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(createHoldingsEventDto),
	}).then((response) => response.payload as CreateHoldingEventDto);
};

export const updateHoldingsEvent = async (
	updateHoldingsEventDto: UpdateHoldingEventDto
): Promise<UpdateHoldingEventDto> => {
	const endpoint = formatUnicorn(API_PATHS.CAP_HOLDINGS_EVENT_UPDATE_HOLDINGS_EVENT_POST, {});
	return makeRequest<ApiV1.Response<UpdateHoldingEventDto>>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(updateHoldingsEventDto),
	}).then((response) => response.payload as UpdateHoldingEventDto);
};

export const deleteHoldingsEvents = async (
	softDeleteHoldingsEventDto: string[]
): Promise<string> => {
	const endpoint = formatUnicorn(
		API_PATHS.CAP_HOLDINGS_EVENT_SOFT_DELETE_HOLDINGS_EVENT_POST,
		{}
	);
	return makeRequest<string>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify({ ids: softDeleteHoldingsEventDto }),
	});
};

export const createBulkHoldingsEvents = async (
	bulkCreateHoldingsEventDto: BulkCreateHoldingEventDto
): Promise<void> => {
	const endpoint = formatUnicorn(
		API_PATHS.CAP_HOLDINGS_EVENT_CREATE_BULK_HOLDINGS_EVENT_POST,
		{}
	);
	return makeRequest<ApiV1.Response<void>>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(bulkCreateHoldingsEventDto),
	}).then((response) => response.payload as void);
};
